import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { seoApi, type SeoIssueListParams } from '../api/seo-api';

import { seoKeys } from './seo-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function seoIssuesQueryOptions(storeId: string, params: SeoIssueListParams) {
  return queryOptions({
    queryKey: seoKeys.issueList(storeId, params),
    queryFn: () => seoApi.issues(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useSeoIssues(storeId: string, params: SeoIssueListParams) {
  return useQuery(seoIssuesQueryOptions(storeId, params));
}
